export const Logo = ({ className = "h-8" }) => (
  <img src="/logo-elysium.png" alt="Elysium" className={`${className} w-auto select-none`} draggable={false} data-testid="app-logo" />
);

export const PageHeader = ({ eyebrow, title, children }) => (
  <div className="mb-8 flex flex-wrap items-end justify-between gap-4 fade-up">
    <div>
      {eyebrow && <div className="micro-label mb-2">{eyebrow}</div>}
      <h1 className="font-display text-3xl font-extrabold tracking-tight sm:text-4xl">{title}</h1>
    </div>
    <div className="flex flex-wrap items-center gap-2">{children}</div>
  </div>
);

export const Field = ({ label, value, mono }) => (
  <div>
    <div className="micro-label mb-1">{label}</div>
    <div className={`text-sm ${mono ? "font-mono" : ""}`}>{value || "—"}</div>
  </div>
);

export const Empty = ({ text, testId }) => (
  <div data-testid={testId} className="border border-dashed p-10 text-center text-sm text-muted-foreground">{text}</div>
);
